<div class="dashboard-wrapper">
  <div class="card d-flex flex-column h-100 w-100">
  <tabset #mainTabs>
    <!-- Account Management - Company information used within the application -->
    @if (
      getFeatureVisibility('admin', 'account-dashboard-account-management')
      ) {
      <tab
        heading="Account Management"
        id="tab1"
        [active]="activeTabId === 'tab1'"
        >
        <app-account-management></app-account-management>
      </tab>
    }
    <!-- User Management - Who has access to application and what role -->
    @if (getFeatureVisibility('admin', 'account-dashboard-user-management')) {
      <tab
        heading="User Management"
        id="tab2"
        [active]="activeTabId === 'tab2'"
        >
        <app-user-management></app-user-management>
      </tab>
    }
    <!-- Payment Management - How user will pay for Easy A&D subscription -->
    @if (
      getFeatureVisibility('admin', 'account-dashboard-payment-management')
      ) {
      <tab
        heading="Payment Management"
        id="tab3"
        [active]="activeTabId === 'tab3'"
        >
        <app-payment></app-payment>
      </tab>
    }
    <!-- This will be for selecting what distributors you use along with login credentials -->
    @if (
      getFeatureVisibility(
      'admin',
      'account-dashboard-distributor-management'
      )
      ) {
      <tab
        heading="Distributor Management"
        id="tab4"
        [active]="activeTabId === 'tab4'"
        >
        <app-distributor-management></app-distributor-management>
      </tab>
    }
    <!-- Accounting options -->
    @if (
      getFeatureVisibility(
      'admin',
      'account-dashboard-distributor-management'
      )
      ) {
      <tab
        heading="Accounting Options"
        id="tab5"
        [active]="activeTabId === 'tab5'"
        >
        <app-accounting-options></app-accounting-options>
      </tab>
    }
    <!-- Change Log -->
    @if (getFeatureVisibility('admin', 'account-dashboard-change-log')) {
      <tab
        heading="Change Log"
        id="tab6"
        [active]="activeTabId === 'tab6'"
        >
        <app-account-change-log></app-account-change-log>
      </tab>
    }
    <!-- Form 3310 auto fill -->
    @if (
      getFeatureVisibility('admin', 'account-dashboard-autofill-form-3310')
      ) {
      <tab
        heading="Autofill From 3310"
        id="tab7"
        [active]="activeTabId === 'tab7'"
        >
        <app-form-3310-autofill></app-form-3310-autofill>
      </tab>
    }
    <!-- Email Config -->
    @if (getFeatureVisibility('admin', 'account-dashboard-email-config')) {
      <tab
        heading="Email Templates"
        id="tab8"
        [active]="activeTabId === 'tab8'"
        >
        <app-email-config></app-email-config>
      </tab>
    }
  </tabset>
  </div>
</div>
